<template>
	<div class="task-log-info height-100 display-flex flex-column">
		<div class="flow_details">
			<TaskLogInfoDetails v-if="selectedTaskInfo" :taskInfo="selectedTaskInfo" :showEditFeatureLink="showEditFeatureLink" />
		</div>
		<div v-if="inputUrlParameters" class="pb-4">
			<div class="url-params">URL parameters</div>
			<perfect-scrollbar>
				<div class="item_box mb-1" v-for="(value, key) in inputUrlParameters" :key="key">
					<span class="var">{{ key }}</span>
					<span class="val pl-2">{{ value }}</span>
				</div>
			</perfect-scrollbar>
			<div class="horizontal-divider pt-2" />
		</div>
		<div :class="{ 'scroll-on-overflow': allowInnerScroll }" class="flex-1">
			<slot name="loader" v-if="isLoading" />
			<LoaderWrapper v-else :isLoading="isLoading">
				<div v-for="task in selectedTaskNodesWithIndex" :key="task.id">
					<TaskLogInfoStep :nodeData="task" :flowData="selectedTaskInfo" />
					<div class="horizontal-divider mb-6 mt-6" />
				</div>
			</LoaderWrapper>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TaskLogInfoDetails from '@/components/TaskLog/TaskLogInfoDetails';
import TaskLogInfoStep from '@/components/TaskLog/TaskLogInfoStep';
import {
	selectedTaskInfo as selectedTaskInfoGetter,
	selectedTaskNodes,
	loadingSelectedTaskNodes,
	taskLog,
} from '@/store/modules/analytics/getters';
import { clearTask, loadTask } from '@/store/modules/analytics/actions';
import { MAPPED_FIELDS_KEY } from '@/utils/workflow-node.const';

import { extractStatusCode, STATUS_CODES } from '@/utils/error-handling-service';

export default {
	name: 'TaskLogInfo',
	components: {
		TaskLogInfoDetails,
		TaskLogInfoStep,
	},
	props: {
		flowRunId: { type: String, required: true },
		allowInnerScroll: { type: Boolean, default: true },
		clearAfterDestroy: { type: Boolean, default: true },
		showEditFeatureLink: { type: Boolean, default: true },
	},
	computed: {
		...mapGetters([selectedTaskInfoGetter.fullPath, taskLog.fullPath, selectedTaskNodes.fullPath, loadingSelectedTaskNodes.fullPath]),
		selectedTaskNodesWithIndex() {
			let seq = 0;
			const copiedArray = this[selectedTaskNodes.fullPath].slice();
			copiedArray.sort((a, b) => new Date(a.created).getTime() - new Date(b.created).getTime());
			return copiedArray.map((task) => {
				seq++;
				task.sequence = seq;
				return task;
			});
		},
		inputUrlParameters() {
			const params = this.selectedTaskInfo?.input?.[MAPPED_FIELDS_KEY]?.url_parameters || this.selectedTaskInfo?.input?.url_parameters;
			return params || undefined;
		},
		isLoading() {
			return !!this[loadingSelectedTaskNodes.fullPath];
		},
		selectedTaskInfo() {
			return this[selectedTaskInfoGetter.fullPath];
		},
	},
	methods: {
		...mapActions([loadTask.fullPath, clearTask.fullPath]),
		async loadTaskWithToastOnError(flowRunId) {
			try {
				await this[loadTask.fullPath](flowRunId);
			} catch (e) {
				if (extractStatusCode(e) === STATUS_CODES.NOT_FOUND) {
					this.$toast.error('Task not found');
				} else {
					throw e;
				}
			}
		},
	},
	beforeDestroy() {
		if (this.clearAfterDestroy) {
			this[clearTask.fullPath]();
		}
	},
	watch: {
		flowRunId: {
			handler() {
				this.loadTaskWithToastOnError(this.flowRunId);
			},
			immediate: true,
		},
	},
};
</script>
